
import { useEffect, useState } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import Loader from '../Layout/Loader';
import { BindGrid, exportToExcel, Amount, setFocus, setTitle } from '../Common/Common';
import { Cookies } from 'react-cookie';
import { API_SERVER } from '../../EnvConfig/env_config';
import { post } from '../Common/service';
import { getCommonData } from '../Common/CommanServices';
import { AlertBox, AutoCompleteBox } from '../Common/Input';
import {  useNavigate } from "react-router-dom";

const ItemPriceMaster = ({ open, setOpen }) => {
    const cookies = new Cookies();
    const Token = cookies.get('token')
    const navigate = useNavigate();
    const LoginUserCode = cookies.get('loginUserCode').toString();
    const [isLoading, setIsLoading] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false)
    const [ItemCodeOption, setItemCodeOption] = useState([]);
    const [ListNumberOption, setListNumberOption] = useState([]);
    const [MenuText, setMenuText] = useState("Item Price Master");

    const [tableData, setTableData] = useState({
        totalRecord: 0,
        gridData:[{

        }]
    })
    const [filterData, setFilterData] = useState({
        SearchFieldValue: "",
        SearchText: "",
        StartValue: "1",
        PageIndex: "1",
    })
    const [SaveData, setSaveData] = useState({
        ItemPriceID: "0",
        ItemCode: "",
        ListNumber: "",
        Price: "0",
        Active: true
    });
    const handleClear = async () => {
        setSaveData({
            ItemPriceID: "0",
            ItemCode: "",
            ListNumber: "",
            Price: "0",
            Active: true
        });

        setFilterData({
            ...filterData,
            SearchText: "",
            StartValue: "1",
            PageIndex: "1",
        });
        setIsUpdate(!isUpdate)
    }
    useEffect(() => {
        setTitle('ItemPriceMaster', setOpen);
        setFocus('txtItemCode')
        setTimeout(() => {
            setMenuText(document.title);
        }, 500)
    }, []);

    useEffect(() => {
        getItemPriceData();
    }, [filterData.PageIndex, isUpdate]);

    const handleSubmit = async () => {
        const loginCodeString = String(LoginUserCode);
        setIsLoading(true)
        let data = {
            ...SaveData, Token, LoginUserCode: loginCodeString
        }
        post(`${API_SERVER}/api/Master/InsertUpdateItemPriceMaster`, { ...data }, (res) => {
            if (res.status === 'SUCCESS') {
                setIsLoading(false);
                AlertBox(res.status, res.message, res.focus)
                handleClear();
                getItemPriceData();
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')

            }
            else if (res.message !== "") {
                AlertBox(res.status, res.message, res.focus)

                setIsLoading(false);
            }
            if (res.focus !== "") {
                setFocus(res.focus);
            }

        })
    }
    const getItemPriceData = async (Type = 'S') => {
        const loginCodeString = String(LoginUserCode);
        const data = {
            ...filterData, Type: Type, Token, LoginUserCode: loginCodeString
        }
        setIsLoading(true)
        post(`${API_SERVER}/api/Master/ShowExItemPriceData`, { ...data }, (res) => {
            if (res.status === 'SUCCESS') {
                const gridDataStr = res.gridData;
                const cleanedGridDataStr = gridDataStr.trim().replace(/\r\n/g, '');
                const gridDataJson = JSON.parse(cleanedGridDataStr);
                if (Type === 'S') {
                    setTableData({
                        ...tableData,
                        gridData: gridDataJson,
                        totalRecord: res.totalRecord
                    });
                }
                else {
                    exportToExcel(gridDataJson, 'ItemPriceMaster');
                }
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.totalRecord <= 0) {
                setTableData(
                    {
                        totalRecord: 0,
                        gridData: [{
                        }]

                    })
            }
            else if (res.message !== "") {
                AlertBox(res.status, res.message, res.focus)
            }
            setIsLoading(false)
        })
    }
    const handleEditData = async (ID) => {
        const loginCodeString = String(LoginUserCode);
        setIsLoading(true)
        let data = {
            Token, LoginUserCode: loginCodeString, ItemPriceID: ID
        }
        post(`${API_SERVER}/api/Master/EditItemPriceData`, { ...data }, (res) => {
            if (res.status === 'SUCCESS') {
                setIsLoading(false);
                const editRecordStr = res.editRecord;
                const cleanededitRecordStr = editRecordStr.trim().replace(/\r\n/g, '');
                const editRecordJson = JSON.parse(cleanededitRecordStr);
                setSaveData({
                    ItemPriceID: ID,
                    ItemCode: editRecordJson[0]['Item'],
                    ListNumber: editRecordJson[0]['PriceList'],
                    Price: editRecordJson[0]['Price'].toString(),
                    Active: (editRecordJson[0]['Active'] === 'YES' ? true : false),
                });
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')

            }
            else if (res.message !== "") {
                AlertBox(res.status, res.message, res.focus)

            }
            if (res.focus !== "") {
                setFocus(res.focus);
            }
            setIsLoading(false);
        })
    }
    const handleDeleteData = async (ID) => {
        setIsLoading(true)
        const loginCodeString = String(LoginUserCode);

        let data = {
            Token, LoginUserCode: loginCodeString, ItemPriceID: ID
        }
        post(`${API_SERVER}/api/Master/DeleteItemPriceData`, { ...data }, (res) => {
            if (res.status === 'SUCCESS') {
                setIsLoading(false);
                AlertBox(res.status, res.message, res.focus)
                getItemPriceData();
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')

            }
            else if (res.message !== "") {
                AlertBox(res.status, res.message, res.focus)
                setIsLoading(false);
            }
        })
    }
    const searchHandle = async () => {
        setFilterData({
            ...filterData,
            PageIndex: "1",
        })
        getItemPriceData();
    }
    const handleDownloadExcel = async () => {
        getItemPriceData('E');
    }
    const getItem = () => {
        setItemCodeOption([]);
        let temp = {
            Type: "GetItemNoForALLItem",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        };
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token,
            LoginUserCode: loginCodeString
        };

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let ItemData = res.autoCompleteData || [];
                setItemCodeOption(ItemData);
            } else {
                setItemCodeOption([]);
            }
        });
    };
    const GetListNo = () => {
        setListNumberOption([]);
        let temp = {
            Type: "GetPriceList",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        };
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token,
            LoginUserCode: loginCodeString
        };

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let ListNoData = res.autoCompleteData || [];
                setListNumberOption(ListNoData);
            } else {
                setListNumberOption([]);
            }
        });
    };
    let ListNoOptionArr = []
    for (let i = 0; i < ListNumberOption.length; i++) {
        let mydata = ListNumberOption[i]?.values
        ListNoOptionArr.push(mydata)
    };
    let ItemOptionArr = []
    for (let i = 0; i < ItemCodeOption.length; i++) {
        let mydata = ItemCodeOption[i]?.values
        ItemOptionArr.push(mydata)
    };

    return (
        <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
            <section className="section dashboard">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box">
                                <div className="heading">
                                    <h6 className="m-0 font-weight-bold text-primary">{MenuText}</h6>
                                </div>
                            </div>
                            <div className="form-box service-content-area">
                                <div className="row align-items-end">
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                          
                                            <AutoCompleteBox
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtListNumber") };
                                                }}
                                                label='Item Code'
                                                placeholder="Item Code"
                                                maxLength='50'
                                                options={ItemOptionArr}
                                                id='txtItemCode'
                                                required={true}
                                                ignore_common={true}
                                                onFocus={() => getItem()}
                                                inputValue={SaveData.ItemCode ? SaveData.ItemCode : ''}
                                                onInputChange={(event, newInputValue) => setSaveData({
                                                    ...SaveData, ItemCode: newInputValue
                                                })
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                           
                                            <AutoCompleteBox
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtPrice") };
                                                }}
                                                label='List No'
                                                placeholder="List No"
                                                maxLength='50'
                                                options={ListNoOptionArr}
                                                id='txtListNumber'
                                                required={true}
                                                ignore_common={true}
                                                onFocus={() => GetListNo()}
                                                inputValue={SaveData.ListNumber ? SaveData.ListNumber : ''}
                                                onInputChange={(event, newInputValue) => setSaveData({
                                                    ...SaveData, ListNumber: newInputValue
                                                })
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Price</label>
                                            <input
                                                id='txtPrice'
                                                type="text"
                                                maxLength="20"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('chkActive')
                                                    };
                                                }}
                                                className="form-control"
                                                placeholder='Enter Price'
                                                value={SaveData.Price}
                                                onChange={(e) => {
                                                    setSaveData({
                                                        ...SaveData, Price: Amount(e.target.value)                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="form-check form-switch">
                                            <label
                                                className="form-check-label"
                                                htmlFor="activeCheckbox"
                                            >
                                                Active
                                            </label>
                                            <input
                                                id='chkActive'
                                                className="form-check-input"
                                                type="checkbox"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('btnSave')
                                                    };
                                                }}
                                                checked={SaveData.Active}
                                                onChange={(e) => {
                                                    setSaveData({
                                                        ...SaveData, Active: e.target.checked
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-12 mt-1">
                                        <div className="lms-new-button text-center">
                                            {SaveData.ItemPriceID !== '0' ? (isLoading ? <button className="button save-btn btn-disable" id='btnSave' disabled={isLoading} >
                                                Please wait...
                                            </button> : <button className="button save-btn" id='btnSave' onClick={handleSubmit}>
                                                <i className="bi bi-check-lg" /> Update
                                            </button>) : (isLoading ? <button className="button save-btn btn-disable" disabled={isLoading} >
                                                Please wait...
                                            </button> : <button className="button save-btn" id='btnSave' onClick={handleSubmit}>
                                                <i className="bi bi-check-lg" /> Save
                                            </button>)}
                                            <button className="button export-btn" onClick={handleDownloadExcel}>
                                                <i className="bi bi-download" /> Export
                                            </button>
                                            <button className="button reset-btn" onClick={handleClear}>
                                                <i className="bi bi-arrow-clockwise" /> Reset
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <BindGrid tableData={tableData} setFilterData={setFilterData} filterData={filterData} searchHandle={searchHandle} handleEditData={handleEditData} handleDeleteData={handleDeleteData} FormName='ItemPriceMaster' />
            
            {isLoading ? <Loader text='Please wait' size='100px' img_path='./assets/img/giphy.gif' /> : <></>}
          
        </main>
    )
}
export default ItemPriceMaster